var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON - shopping cart",
    clipPath: "url(#clip0_760_556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.8281 6.57337C22.4098 6.00262 21.763 5.64159 21.057 5.58534L6.44995 4.42847L6.18441 2.92406C5.94164 1.55039 4.84861 0.486656 3.46885 0.282562L3.20344 0.242953L1.62431 0.00867181C1.18439 -0.0559219 0.775033 0.247266 0.709783 0.687187C0.644393 1.12748 0.94819 1.53689 1.38811 1.60191V1.60153L3.23297 1.875L3.23339 1.87622C3.92658 1.97766 4.4768 2.51306 4.59891 3.20391L7.09913 17.3743C7.33374 18.7044 8.48883 19.6734 9.83949 19.6738H20.1141C20.559 19.6738 20.9192 19.3132 20.9192 18.8689C20.9192 18.4242 20.559 18.0636 20.1141 18.0636H9.83944C9.27071 18.064 8.78306 17.6546 8.68435 17.0946L8.33461 15.1118H19.7881C20.922 15.1118 21.9057 14.3294 22.1603 13.2245L23.2369 8.55938C23.3963 7.8697 23.2468 7.14487 22.8281 6.57337Z",
    fill: "#FCFBFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4537 20.537C9.4974 20.537 8.72241 21.3129 8.72241 22.2689C8.72241 23.2249 9.4974 24 10.4537 24C11.41 24 12.1855 23.2249 12.1855 22.2689C12.1854 21.3129 11.41 20.537 10.4537 20.537Z",
    fill: "#FCFBFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.1466 20.537C17.1901 20.537 16.4153 21.3129 16.4153 22.2689C16.4153 23.2249 17.1901 24 18.1466 24C19.103 24 19.8784 23.2249 19.8784 22.2689C19.8784 21.3129 19.103 20.537 18.1466 20.537Z",
    fill: "#FCFBFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8264b6b8ac7a36db921fd75866e5709a.svg";
export { ForwardRef as ReactComponent };